import { Editable, EditableInput, EditablePreview, HStack, useEditableControls } from '@chakra-ui/react';
import { UilEditAlt } from '@iconscout/react-unicons';

function setPageName({ name, editPageProps, setEditPageProps }) {
	const newPageInfo = { ...editPageProps };
	newPageInfo.pageName = name;
	setEditPageProps(newPageInfo);
}

const EditPageName = ({ editPageProps, setEditPageProps }) => {
	return (
		<Editable
			_hover={{ cursor: 'pointer' }}
			onChange={(name) => setPageName({ name, editPageProps, setEditPageProps })}
			value={editPageProps.pageName}
			defaultValue={editPageProps.pageName ? editPageProps.pageName : 'Nova página'}
		>
			<HStack alignItems={'center'}>
				<EditablePreview _hover={{ cursor: 'pointer' }} />
				<EditableInput ml={'0 !important'} />
				<EditableControls />
			</HStack>
		</Editable>
	);
};

const EditableControls = () => {
	const { isEditing, getEditButtonProps } = useEditableControls();
	return !isEditing ? <UilEditAlt size={'16'} {...getEditButtonProps()} /> : null;
};
export default EditPageName;
